import { render } from "./k-app-sidebar.vue?vue&type=template&id=70e42eeb"
import script from "./k-app-sidebar.vue?vue&type=script&lang=js"
export * from "./k-app-sidebar.vue?vue&type=script&lang=js"

import "./k-app-sidebar.vue?vue&type=style&index=0&id=70e42eeb&lang=css"

import exportComponent from "../../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__